import { createApp } from 'vue'
import { IonicVue } from '@ionic/vue'
import { createRouter, createWebHistory } from '@ionic/vue-router'
// import { konstaConfig } from 'konsta/config'
import App from './App.vue'
import Home from './views/Home.vue'
import Profile from './views/Profile.vue'
import Leaderboard from './views/Leaderboard.vue'
import Rewards from './views/Rewards.vue'
import AuthTestView from './views/AuthTestView.vue'
import { initializeData } from './services/initializeData'
import { createPinia } from 'pinia'
import i18n from './i18n'

// Whitelabel integration - Subtask 4.3
import { initializeWhitelabel, getWhitelabelConfig } from './config/whitelabel'
import { applyWhitelabelTheme } from './theme/whitelabel'

// Task 5: Vue configuration access via provide/inject pattern
import { WhitelabelConfigInjectionKey } from './types/whitelabel'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css'

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css'
import '@ionic/vue/css/structure.css'
import '@ionic/vue/css/typography.css'

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css'
import '@ionic/vue/css/float-elements.css'
import '@ionic/vue/css/text-alignment.css'
import '@ionic/vue/css/text-transformation.css'
import '@ionic/vue/css/flex-utils.css'
import '@ionic/vue/css/display.css'

/* Theme variables */
import './theme/variables.css'
/* Tailwind CSS */
import './theme/tailwind.css'

// Initialize whitelabel configuration
console.log('🚀 Initializing application...')
initializeWhitelabel()

// Apply whitelabel theme before Vue app initialization
applyWhitelabelTheme()

// Initialize default data if needed
initializeData()

// Base production routes
const baseRoutes = [
  { 
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { tab: 'home' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { tab: 'profile' }
  },
  {
    path: '/leaderboard',
    name: 'Leaderboard',
    component: Leaderboard,
    meta: { tab: 'leaderboard' }
  },
  {
    path: '/rewards',
    name: 'Rewards',
    component: Rewards,
    meta: { tab: 'rewards' }
  }
]

// Development-only routes
const devRoutes = import.meta.env.DEV ? [
  {
    path: '/auth-test',
    name: 'AuthTest',
    component: AuthTestView
  },
  {
    path: '/whitelabel-example',
    name: 'WhitelabelExample',
    component: () => import('./components/examples/WhitelabelExampleComponent.vue'),
    meta: { title: 'Whitelabel Configuration Example' }
  }
] : []

const router = createRouter({
  history: createWebHistory(),
  routes: [...baseRoutes, ...devRoutes]
})

const app = createApp(App)

// Task 5: Proper whitelabel configuration provider - Subtask 5.1
try {
  const whitelabelConfig = getWhitelabelConfig()
  app.provide(WhitelabelConfigInjectionKey, whitelabelConfig)
  console.log('✅ Whitelabel configuration provided to Vue app')
} catch (error) {
  console.error('❌ Failed to provide whitelabel configuration:', error)
  console.warn('🔄 Application will continue with fallback configuration')
  // Don't provide config - composable will handle fallback
}

// Store configuration on window for debugging in development - Subtask 4.4
if (import.meta.env.DEV) {
  try {
    const whitelabelConfig = getWhitelabelConfig()
    ;(window as any).whitelabelConfig = whitelabelConfig
    console.log('🐛 Whitelabel config available on window.whitelabelConfig')
  } catch (error) {
    console.warn('🐛 Could not expose config to window:', error)
  }
}

app.use(createPinia())
app.use(IonicVue)
app.use(router)
app.use(i18n)

router.isReady().then(() => {
  app.mount('#app')
  console.log('✅ Application mounted successfully')
  
  // Log theme application status in development - Subtask 4.4
  if (import.meta.env.DEV && (window as any).whitelabelTheme) {
    console.log('🎨 Theme status:', (window as any).whitelabelTheme.status())
  }
}) 